import * as React from "react";
import { ThemeContext } from "../../components/theme/ThemeContext";
import { PropsWithChildren } from "react";

export const GlobalProvider: React.FC<PropsWithChildren> = props => {
  // Clear cache  control
  return <ThemeContext.Provider value="light">{props.children}</ThemeContext.Provider>;
};
